import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import logo from "@/assets/logo.png";
import { registerServiceWorker } from "@/lib/pwa";

const favicon = document.querySelector("link[rel='icon']") || document.createElement("link");
favicon.rel = "icon";
favicon.type = "image/png";
favicon.href = logo;
document.head.appendChild(favicon);

const faviconImage = new Image();
faviconImage.onload = () => {
  const canvas = document.createElement("canvas");
  canvas.width = 64;
  canvas.height = 64;
  const context = canvas.getContext("2d");
  context.fillStyle = "#212529";
  context.fillRect(0, 0, 64, 64);
  context.drawImage(faviconImage, 760, 120, 760, 650, 4, 4, 56, 56);
  favicon.href = canvas.toDataURL("image/png");
};
faviconImage.src = logo;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);

registerServiceWorker();
